export default function buildPromiseResolver() {
    let promise, resolve, reject;
    promise = new Promise((res, rej) => {
        resolve = res;
        reject = rej;
    });
    // @ts-ignore
    return { promise, resolve, reject };
}
//# sourceMappingURL=promise-resolver.js.map